export default {
      id: "icon-edit-usage",
      viewBox: "-3 -3 24 24",
      url: __webpack_public_path__ + "svg-sprite-defs.svg#icon-edit",
      toString: function () {
        return this.url;
      }
    }